/**
 * Can be used with the nullish coalescing operator to throw an error if you expect a nullable type not to be null or undefined.
 * Eg:
 * <code>
 *     somethingThatCanBeNullOrUndefinedButShouldnt ?? throwError("Oh no, this nullable type appears to be null or undefined and this is not allowed!!")
 * </code>
 *
 * @param errorMessage
 */
export function throwError(errorMessage: string): never {
    throw new Error(errorMessage);
}
